export default __webpack_public_path__ + "static/media/Rasengan.87765e7c.mp3";